function calcCompletion(tournament, stage, prediction, allItems) {

    let percentage = 0;

    if(tournament === "weuro2025" && stage === "group" && Boolean(prediction)) {
        let matches = allItems.filter((m) => m.tournament === tournament && m.stage === stage)
        let noCompleted = matches.filter((m) => prediction.some((p) => p.matchid === m._id && 
            (p.home !== undefined && p.home !== null && p.home !== '') &&
            (p.away !== undefined && p.away !== null && p.away !== ''))).length
        percentage = Math.round(noCompleted / matches.length * 100);

    } else if(tournament === "weuro2025" && stage === "knockout" && Boolean(prediction)) {
        let matches = allItems.filter((m) => m.stage.startsWith("final"))
        let predictions = prediction.filter((p) => matches.some((m) => m._id === p.matchid))
        let counter = 0;
        predictions.forEach((p) => {
            counter = counter + (Boolean(p.homeTeamID) ? 1 : 0) + (Boolean(p.awayTeamID) ? 1 : 0)
        })
        percentage = Math.round(counter / (matches.length * 2) * 100)

    } else if(tournament === "weuro2025" && stage === "questionnaire" && Boolean(prediction)) {
        let noQuestions = allItems.length
        let noCompleted = prediction.filter((p) => ['questionnaire'].includes(p.stage)).length
        percentage = Math.round(noCompleted / noQuestions * 100)
    }

    return percentage

}

export default calcCompletion